const UTM_STORAGE_KEY = "GailUtmData";

const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

interface UtmData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  referrer?: string;
}

export function captureUtmData(): void {
  if (!globalThis.window) return;

  try {
    if (localStorage.getItem(UTM_STORAGE_KEY)) return;

    const params = new URLSearchParams(globalThis.window.location.search);
    const data: UtmData = {};

    for (const key of UTM_PARAMS) {
      const value = params.get(key);
      if (value) {
        data[key] = value;
      }
    }

    if (document.referrer) {
      try {
        const referrerUrl = new URL(document.referrer);
        if (referrerUrl.origin !== globalThis.window.location.origin) {
          data.referrer = document.referrer;
        }
      } catch {
        // Invalid referrer URL, skip
      }
    }

    if (Object.keys(data).length > 0) {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(data));
    }
  } catch {
    // localStorage may be unavailable
  }
}

export function getStoredUtmData(): UtmData | undefined {
  if (!globalThis.window) return undefined;

  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    if (!raw) return undefined;
    return JSON.parse(raw) as UtmData;
  } catch {
    return undefined;
  }
}

export function buildSignUpUrlWithUtm(baseUrl: string): string {
  const data = getStoredUtmData();
  if (!data) return baseUrl;

  const url = new URL(baseUrl);
  for (const [key, value] of Object.entries(data)) {
    if (value) {
      url.searchParams.set(key, value);
    }
  }

  return url.toString();
}
